export abstract class DialogService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract action(title: string, actions: any[]);
}
